import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import routes from '../../../constants/routes';
import { clearProfileState } from '../../../redux/slices/ProfileSlice';
import { clearPaymentUserState } from '../../../redux/slices/PaymentUserSlice';
import { RootState } from '../../../redux/store';
import { useNavigate } from 'react-router-dom';

const useAuthRedirect = (email?: string) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.profile);
  const [isAuthCheckInProgress, setIsAuthCheckInProgress] = useState(true);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const token = window.localStorage.getItem('token');

      if (!isEmpty(user) && token) {
        window.location.href = routes.ADMIN_HOME;
        return;
      }

      if (isEmpty(email)) {
        localStorage.removeItem('user');
        dispatch(clearProfileState());
        dispatch(clearPaymentUserState());
        removeNativeUserFlag();
        navigate(routes.ADMIN_LOGIN);
        setIsAuthCheckInProgress(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, email, dispatch]);

  return isAuthCheckInProgress;
};

const saveNativeUserFlag = () => {
  window.localStorage.setItem('isNativeUserLoggedIn', 'true');
};

const removeNativeUserFlag = () => {
  window.localStorage.removeItem('isNativeUserLoggedIn');
};

const saveEasypayToken = (token: string) => {
  window.localStorage.setItem('easypayToken', token);
};

const getNativeUserFlag = () => {
  return window.localStorage.getItem('isNativeUserLoggedIn') === 'true';
};

export {
  useAuthRedirect,
  saveNativeUserFlag,
  removeNativeUserFlag,
  getNativeUserFlag,
  saveEasypayToken
};
